import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContractsService } from 'src/app/services/contracts/contracts.service';
import { GoogleTagManagerService } from 'src/app/services/google-tag-manager.service';

export interface DialogData {

  icon:string,
  textIcon:string,
  pdf:string
  
}



@Component({
  selector: 'app-modal-contract-document',
  templateUrl: './modal-contract-document.component.html',
  styleUrls: ['./modal-contract-document.component.scss']
})
export class ModalContractDocumentComponent implements OnInit {

  linkPdf: any;

  constructor(
    public contracts: ContractsService, 
    public dialog: MatDialog, 
    public dialogRef: MatDialogRef<ModalContractDocumentComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private gtmService: GoogleTagManagerService
  ) { }

  async ngOnInit(): Promise<void> {
    await this.contracts.downloadPdf();
  }

  closeModal(): void {
    this.dialogRef.close();
  }

  onDownloadClick(){
    this.gtmService.push({
      event: 'downloadContract'
    });
    this.linkPdf = this.contracts.downloadPdf();
    //this.contracts.download();
  }

}
